

import {typesStoredcardall} from './svtypes/crdrs'
import _ from 'lodash'

/*
//http://svabode-1420502022.us-west-1.elb.amazonaws.com/essearch/svuila
//POST http://localhost:8080/essearch/svuila
rq
{
  "query": {
    "match": {
      "sojourn_name": {
        "query": "mancreek",
        "operator": "and"
      }
    }
  }
}



*/
let initStore = {
    loading: false,
    error: false,
    errob :{
      "timestamp": "2015-08-23T02:27:18.038+0000",
      "status": 500,
      "error": "Default Error",
      "message": "500 null",
      "path": "/kk/svaddressDetailPost"
  },
  my_data_geo:{
    "countryTypes": [
        {
            "name": "United STates America",
            "a2": "US",
            "a3": "USA",
            "value": "USA",
            "isonum": "840"
        },
        {
            "name": "Canada",
            "isdcode": "01",
            "a2": "CA",
            "a3": "CAN",
            "value": "CAN",
            "isonum": "124"
        }
    ],
    "stateTypes": [
        {
            "name": "California",
            "value": "CA",
            "a2": "CA"
        },
        {
            "name": "New York",
            "value": "NY",
            "a2": "NY"
        },
        {
            "name": "Texas",
            "value": "TX",
            "a2": "TX"
        }
    ],
    "isdcodeTypes": [
        {
            "name": "United States Of America(+1)",
            "value": "1"
        },
        {
            "name": "Australia(+61)",
            "value": "61"
        },
        {
            "name": "Spain(+34)",
            "value": "34"
        }
    ],
    "genderTypes": [
        {
            "name": "CL_MALE",
            "value": "MALE"
        },
        {
            "name": "CL_FEMALE",
            "value": "FEMALE"
        }
    ]
},
    
    my_data_storedcardlist: [
        {
            "cardId": 3,
            "customerId": 3,
            "paymentMethodCode": "card",
            "paymentType": "self",
            "productDetails": "svr",
            "description": "my hw default",
            "cardNumber": "5123412341234123",
            "cardCvv": "111",
            "cardExpMonth": "01",
            "cardExpYear": "31",
            "email": "alen@br.com",
            "isValid": "Y",
            "cardDelete": "N",
            "cardBlock": "N",
            "createdDate": "2024-08-05T04:00:00.000+0000",
            "modifiedDate": "2024-08-05T04:00:00.000+0000",
            "createdBy": "AbodeSystemAdmin",
            "modifiedBy": "AbodeSystemAdmin",
            "name": null,
            "fname": null,
            "lname": null,
            "phone": null,
            "address": null,
            "zip": null,
            "isdcode": null
        }
    ]
}

export default (state = initStore, action) => {
    console.log(action);
    let januState = null, svns= null;
    switch (action.type) {
        case "sojourns/LIST_SOJOURNS":

     console.log('tasks LIST_SOJOURNS reducer')
     
    
      console.log(svns)
      if(Array.isArray(action.sojourns) && (action.sojourns.length >0)){
       
        state.sojourns =_.clone(action.sojourns)
      }
     svns = Object.assign({}, state, {sojourns:action.sojourns})
      console.log('sv reduce --for LIST_TASKS')
      console.log(svns)

      return svns
        case "GET_STOREDCARDALL_SUCCESS":
            console.log("reduce %%%%%%%%evsearcg  success*****************");
            console.log(action.payload.my_data_storedcardlist);
            // let januState = {...state, loading: false, my_data_storedcardlist: action.payload.my_data_storedcardlist}
             januState = {...state,error:false, loading: false, my_data_geo:action.payload.my_data_geo, my_data_storedcardlist: action.payload.my_data_storedcardlist, svr_soj_images: action.payload.my_images}
            return januState
        case 'GET_STOREDCARDALL_BEGIN':
                console.log("loading")
                return {...state, loading: true}
        case typesStoredcardall.GET_STOREDCARDALL_BEGIN:
            console.log("loading")
            return {...state, loading: true}
        case typesStoredcardall.GET_STOREDCARDALL_ERROR:
          console.log("error")
          console.log(action.payload.errob)
          const errjson = {
              "timestamp": "2024-08-23T02:27:18.038+0000",
              "status": 500,
              "error": "Internal Server Error",
              "message": "500 null",
              "path": "/accountclient/svaddressDetailPost"
          }
          return {...state,errob:action.payload.errob, error: true}

           
        default:
            return state
    }
}